import { useQuery } from "@tanstack/react-query";

import TokenHelper from "@/utils/tokenHelper";
import { QUERY_KEYS } from "@api/queryKeys";

import {
  adaptRegistryAgency,
  adaptRegistryAgencyName,
} from "./adaptRegistryAgencyFilter.data";
import { publicationRegistryAgencyApi } from "./registryAgencyFilter.service";

export const useRegistryAgencyQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.registryAgency],
    queryFn: () => publicationRegistryAgencyApi.getRegistryAgencyData(),
    throwOnError: false,
    select: (data) => adaptRegistryAgency(data.data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};

export const useRegistryAgencyNameQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.registryAgency],
    queryFn: () => publicationRegistryAgencyApi.getRegistryAgencyData(),
    throwOnError: false,
    select: (data) => adaptRegistryAgencyName(data.data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};
